import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {fetchWrapper} from "../../helpers";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import {Link} from "react-router-dom";
import arrowRightIcon from "../icons/arrow-right-content.svg"; // Replace with path to your Google icon
import {PlanCard} from "../ContentPlan/PlanCard";
import "./style.css";
import {
    Layout, Row, Col, Card, Space, Typography, Button, Input, Select,
    Divider, Tooltip, Badge, Spin, Pagination, notification
} from "antd";
import {
    PlusOutlined,
    ReloadOutlined,
} from "@ant-design/icons";
import {useSelector} from "react-redux";
import {jwtDecode} from "jwt-decode";
import {mergeStateObject} from "../../utils/merger";
import AppNavigation from "../../components/AppNavigation";
import {ImeanHeader} from "../../components/Header/Header";
import {StickyNavigationHeader} from "../../components/Navigation/StickyNavigationHeader";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const Posts = () => {
    const [fbPageId, setFbPageId] = useState("");
    const user = useSelector((obj) => obj.auth.user);
    const [localUser, setLocalUser] = useState(JSON.parse(localStorage.getItem("user")));
    const [posts, setPosts] = useState([]);
    const [isPostsLoading, setIsPostsLoading] = useState(true);
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const [strategy, setStrategy] = useState(false);
    const [tokens, setTokens] = useState({
        facebook: false,
        instagram: false,
        linkedIn: false,
    });
    const [pagination, setPagination] = useState({
        page: 1,
        size: +localStorage.getItem("paginationSize") || 10,
        count: 0,
    });
    const [token, setToken] = useState("");
    const [sortBy, setSortBy] = useState('date');
    const [sortOrder, setSortOrder] = useState('desc');
    const [searchQuery, setSearchQuery] = useState('');

    const openNotification = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/personal-brand")}>
                    {t("functions.generate")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("functions.error"),
            description: t("contentPlan.strategyError"),
            btn,
            key,
        });
    };

    const openNotificationLinkedIn = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/profile")}>
                    {t("profile.linkAccount")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("contentPlan.tokenError"),
            btn,
            key,
        });
    };

    const submit = () => {
        const hasAnyToken = tokens.facebook || tokens.instagram || tokens.linkedIn;

        if (!hasAnyToken) {
            openNotificationLinkedIn();
            // }else if(strategy === false){
            //     openNotification()
        } else {
            navigate("/generate-post");
        }
    };

    useEffect(() => {
        let cancelled = false
        setIsPostsLoading(true);

        fetchWrapper
            .get(`${baseUrl}/post/all?page=${pagination.page}&limit=${pagination.size}&sortBy=${sortBy}&sortOrder=${sortOrder}&search=${searchQuery}`)
            .then((res) => {
                if (cancelled) return;
                setPosts(res?.posts || []);
                mergeStateObject(setPagination, {count: res?.count || 0});
            })
            .catch(() => {
                if (cancelled) return;
                setPosts([]);
            })
            .finally(() => {
                if (cancelled) return;
                setIsPostsLoading(false);
            })

        return () => {
            cancelled = true;
        }
    }, [pagination.page, pagination.size, sortBy, sortOrder, searchQuery]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            mergeStateObject(setPagination, {page: 1});
        }, 500); // 500ms delay

        return () => clearTimeout(timeoutId);
    }, [searchQuery]);

    useEffect(() => {
        mergeStateObject(setPagination, {page: 1});
        setIsPostsLoading(true);
    }, [sortBy, sortOrder]);

    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/profile/`).then((res) => {
            setFbPageId(res.facebookPageId);
        });

        fetchWrapper.get(`${baseUrl}/strategy/actual/`).then((res) => {
            if (res[0] != null) {
                setStrategy(true);
            }
        });
        fetchWrapper.get(`${baseUrl}/auth/getSocialMediaTokens/`).then((res) => {
            res.forEach((t) => {
                if (t.socialMediaType == "LINKEDIN") {
                    setToken(t.accessToken);
                }
                if (t.socialMediaType == "FACEBOOK") {
                    setToken(t.accessToken);
                }
                if (t.socialMediaType == "INSTAGRAM") {
                    setToken(t.accessToken);
                }
            });
        });
    }, []);

    useEffect(() => {
        fetchWrapper
            .get(`${baseUrl}/auth/getSocialMediaTokens/`)
            .then((res) => {
                const filteredToken = {
                    facebook: false,
                    instagram: false,
                    linkedIn: false,
                };
                res.forEach((token) => {
                    if (token.socialMediaType === "FACEBOOK") {
                        filteredToken.facebook = true;
                    }
                    if (token.socialMediaType === "INSTAGRAM") {
                        filteredToken.instagram = true;
                    }
                    if (token.socialMediaType === "LINKEDIN") {
                        filteredToken.linkedIn = true;
                    }
                });
                setTokens(filteredToken);
            })
            .catch(() => {
            });
    }, []);

    return (
        <Layout style={{minHeight: "100vh", background: "linear-gradient(180deg, #ffffff, #faf5ff)"}}>
            {notificationContextHolder}
            {/* Sticky, glassy top bar */}
            <ImeanHeader initialDark={true}></ImeanHeader>
            <StickyNavigationHeader headerTitle={t('posts.header')} onBackClick={() => navigate('/home')} actions={
                <Button type="primary" icon={<PlusOutlined />} onClick={submit}>
                    {t('home.createPost')}
                </Button>
            }/>

            <Layout.Content style={{maxWidth: 1200, margin: "24px auto", width: "100%", padding: "0 16px"}}>
                {/* Gating (survey) */}
                {localUser?.strategiesCount ? null : (
                    <Card className="shadow-sm" bodyStyle={{padding: 24, textAlign: "center", borderRadius: 12}}>
                        <Typography.Title level={5} style={{marginBottom: 8}}>
                            {t("post.needSurveyText")}
                        </Typography.Title>
                        <Button type="primary" onClick={() => navigate("/survey")}>
                            {t("contentPlan.goToSurveyBtnText")}
                        </Button>
                    </Card>
                )}

                {/* Toolbar */}
                <Card className="shadow-sm" style={{marginTop: 16}} bodyStyle={{padding: 16}}>
                    <Row gutter={[12, 12]} align="middle" justify="space-between">
                        <Col xs={24} lg={12}>
                            <Space wrap>
                                {/* Кнопка создания поста удалена по требованию */}
                                <Input.Search
                                    allowClear
                                    placeholder={t("functions.searchPosts")}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onSearch={() => {
                                        mergeStateObject(setPagination, {page: 1});
                                    }}
                                    style={{minWidth: 220, maxWidth: 360}}
                                />
                            </Space>
                        </Col>
                        <Col xs={24} lg="auto">
                            <Space wrap split={<Divider type="vertical"/>}> {/* сортировки */}
                                <Space>
                                    <Typography.Text type="secondary">{t("functions.sortBy")}:</Typography.Text>
                                    <Select
                                        value={sortBy}
                                        onChange={(v) => setSortBy(v)}
                                        style={{width: 160}}
                                        options={[
                                            {value: "date", label: t("functions.date")},
                                            {value: "name", label: t("functions.name")},
                                        ]}
                                    />
                                </Space>
                                <Space>
                                    <Typography.Text type="secondary">{t("functions.order")}:</Typography.Text>
                                    <Select
                                        value={sortOrder}
                                        onChange={(v) => setSortOrder(v)}
                                        style={{width: 160}}
                                        options={[
                                            {value: "asc", label: t("functions.ascending")},
                                            {value: "desc", label: t("functions.descending")},
                                        ]}
                                    />
                                </Space>
                                <Space>
                                    <Typography.Text type="secondary">{t("functions.pageSize")}:</Typography.Text>
                                    <Select
                                        value={pagination.size}
                                        onChange={(size) => {
                                            localStorage.setItem("paginationSize", size);
                                            mergeStateObject(setPagination, {page: 1, size});
                                            setIsPostsLoading(true);
                                        }}
                                        style={{width: 120}}
                                        options={[5, 10, 20, 50].map((n) => ({value: n, label: n}))}
                                    />
                                </Space>
                            </Space>
                        </Col>
                    </Row>
                </Card>

                {/* Posts list */}
                <div style={{marginTop: 16}}>
                    {isPostsLoading ? (
                        <Card className="shadow-sm" bodyStyle={{padding: 32, textAlign: "center"}}>
                            <Space direction="vertical" align="center">
                                <Spin size="large"/>
                                <Typography.Text type="secondary">{t("functions.loading")}</Typography.Text>
                            </Space>
                        </Card>
                    ) : posts?.length ? (
                        <Row gutter={[16, 16]}>
                            {posts.map((post, index) => (
                                <Col xs={24} key={post?.id || index}>
                                    {/* Keep your PlanCard exactly as you use it today */}
                                    <PlanCard
                                        item={{...post.ContentPlan, id: post.ContentPlan.id, uniqueIndexId: post.id}}
                                        index={index}
                                        fbPageId={fbPageId}
                                        isQuickPublication={true}
                                        snTokens={tokens}
                                        onCardClick={() => navigate(`/create-post/${post.ContentPlan.id}`)}
                                    />
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <Card className="shadow-sm" bodyStyle={{padding: 32, textAlign: "center"}}>
                            <Space direction="vertical">
                                <Typography.Title level={5} style={{margin: 0}}>
                                    {t("posts.noPostsTitle") || "No posts yet"}
                                </Typography.Title>
                                <Typography.Text type="secondary">
                                    {t("posts.noPostsHint") || "Create your first post to see it here."}
                                </Typography.Text>
                                <Button type="primary" icon={<PlusOutlined/>} onClick={submit}>
                                    {t("home.createPost")}
                                </Button>
                            </Space>
                        </Card>
                    )}
                </div>

                {/* Pagination */}
                {(posts?.length > 0 || pagination.page > 1) && (
                    <Card className="shadow-sm" style={{marginTop: 16}} bodyStyle={{padding: 16}}>
                        <Row justify="center">
                            <Pagination
                                size={window.innerWidth < 520 ? "small" : "default"}
                                hideOnSinglePage
                                disabled={isPostsLoading}
                                onChange={(page, pageSize) => {
                                    localStorage.setItem("paginationSize", pageSize);
                                    mergeStateObject(setPagination, {page});
                                    setIsPostsLoading(true);
                                    window.scrollTo({top: 0, behavior: "smooth"});
                                }}
                                current={pagination.page}
                                pageSize={pagination.size}
                                total={pagination.count}
                                showSizeChanger={false}
                            />
                        </Row>
                    </Card>
                )}
            </Layout.Content>

            {/* Sticky, glassy bottom bar */}
            {/* Footer удалён по требованию */}

            {/* App bottom nav spacer & component */}
            <div style={{height: 70}}/>
            <AppNavigation/>
        </Layout>
    );

};
